import { CalculatorLayout } from '../CalculatorLayout';
import { ReviewPage } from '../ReviewPage/ReviewPage';

export const ReviewPageWrapper = () => {
  return (
    <CalculatorLayout additionalClasses={'after:w-4/5'} currentSectionNumber={4}>
      <div className={'md:w-11/12'}>
        <ReviewPage />
      </div>
    </CalculatorLayout>
  );
};
